import Tooltip from "@kea-mod/common/tooltip";
import { useTranslation } from "react-i18next";
import type { Exercise } from "../../../types/Exercise";

type Props = {
  activeExercise: Exercise;
  h: Function;
};

export const QuestionField = (props: Props) => {
  const { t } = useTranslation();

  const onChange = (event: any) => {
    props.h(event);
  };

  return (
    <div className="field">
      <label className="label" htmlFor="question">
        {t("question")}
        <Tooltip
          icon="circle-info"
          class="icon tooltip no-border is-white   has-tooltip-multiline has-tooltip-top"
          content={t("questionTooltip")}
        ></Tooltip>
      </label>
      <input
        type="text"
        className="input"
        id="question"
        name="question"
        value={props.activeExercise.understanding.question}
        onChange={onChange}
      />
    </div>
  );
};
